import useSWR from "swr";

import {
  defaultPageNumber as defaultPageNumber,
  defaultPageSize as defaultPageSize,
} from "@/constants/pagination";
import SWR_KEYS from "@/constants/swr-keys";
import { IPlatform } from "@/interfaces/platform.interfaces";
import platformService from "@/services/platform.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetPlatformsReturn = RequestsBaseReturn<PaginatedResponse<IPlatform> | null>;

export type UseGetAllPlatformsProps = Partial<RequestPagination>;
type GetAllPlatformsSwrParams = [string, number, number];

const useGetAllPlatforms = ({
  pageNumber = defaultPageNumber,
  pageSize = defaultPageSize,
}: UseGetAllPlatformsProps = {}): UseGetPlatformsReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<IPlatform>, Error, GetAllPlatformsSwrParams>(
    [SWR_KEYS.getPlatforms, pageNumber, pageSize],
    ([, _pageNumber, _pageSize]) =>
      platformService.getAll({ pageNumber: _pageNumber, pageSize: _pageSize }),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetAllPlatforms;
